import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAirplaneContainerList(params) {
  return request({
    url: URL.mdm.basicData.airplaneContainer,
    method: 'get',
    params
  })
}

export function getNoPaginationAirplaneContainerList(params) {
  return request({
    url: URL.mdm.basicData.allAirplaneContainer,
    method: 'get',
    params
  })
}

export function getAirplaneContainersByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformAirplaneContainer,
    method: 'get',
    params
  })
}

export function getAllAirplaneContainerTemplate(params) {
  return request({
    url: URL.mdm.basicData.airplaneContainerTemplate,
    method: 'get',
    params
  })
}

export function saveAirplaneContainer(data) {
  return request({
    url: URL.mdm.basicData.airplaneContainer,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addAirplaneContainerByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformAirplaneContainer,
    method: 'post',
    data
  })
}

export function saveAirplaneContainers(data) {
  return request({
    url: URL.mdm.basicData.airplaneContainers,
    method: 'post',
    data
  })
}

export function delAirplaneContainer(data) {
  return request({
    url: URL.mdm.basicData.delAirplaneContainer,
    method: 'post',
    data
  })
}
